<template>
    <div
        class="footer"
        :class="{
            'footer--products': route === 'Products',
            'footer--contact': route === 'Contact'
        }"
    >
        <div class="footer__wrapper">
            <a href="https://www.facebook.com/ALKOHOLANDIA" target="_blank" rel="noopener" class="svg-facebook-icon">
                <svg-icon icon="facebook-icon"/>
            </a>

            <ul class="footer__links">
                <li
                    v-for="link in links"
                    :key="link.id"
                    class="footer__link"
                >
                    <router-link :to="`/${link.route}`">
                        {{ link.title }}
                    </router-link>
                </li>
            </ul>
        </div>

        <stores-list
            v-if="userDevice === 'desktop'"
            class="footer__store-list"
        />

        <p class="footer__copy-right">
            All rights reserved ©
        </p>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import StoresList from '@/components/StoresList'

export default {
    name: 'Footer',
    components: {
        SvgIcon,
        StoresList,
    },
    computed: {
        lang() {
            return this.$parent.lang
        },
        links() {
            return [
                {
                    title: this.lang.links.home,
                    route: '',
                },
                {
                    title: this.lang.links.stores,
                    route: 'stores',
                },
                {
                    title: this.lang.links.about,
                    route: 'about',
                },
                {
                    title: this.lang.links.contact,
                    route: 'contact',
                },
            ]
        },
        route() {
            return this.$route.name
        },
        userDevice() {
            return this.$parent.userDevice
        },
    },
}
</script>

<style lang="scss">
.footer {
    display: flex;
    width: 100vw;
    padding: 24px 24px 6px;
    flex-direction: column;
    background-color: #001d27;

    @media (min-width: 1024px) {
        position: relative;
        padding-top: 66px;
        flex-direction: row;
    }

    @media (min-width: 1366px) {
        margin: 0 auto;
    }

    @media (min-width: 1920px) {
        padding: 66px 12% 24px;
    }

    &__wrapper {
        display: contents;
    }

    &__store-list {
        @media (min-width: 1024px) {
            display: flex;
            padding-left: 24px;
            border-left: 1px solid #57e2e2;
            color: white;
            font-size: 15px;
            text-align: left;

            @media (min-width: 1366px) {
                right: 170px;
                font-size: 16px;
            }

            @media (min-width: 1920px) {
                right: 20%;
            }

            h2 {
                font-size: 20px;
            }

            .stores-list__item {
                margin-right: 12px;
            }
        }
    }

    &__links {
        margin: 80px auto auto;
        padding: 0;
        text-align: left;

        @media (min-width: 1024px) {
            margin: auto 24px auto 0;
        }

        @media (min-width: 1366px) {
            margin-left: 154px;
        }
    }

    &__link {
        margin-bottom: 12px;
        list-style-type: none;
        text-transform: capitalize;

        a {
            color: white;
            font-size: 16px;
            font-weight: 300;
            text-decoration: none;

            @media (min-width: 414px) {
                font-size: 18px;
            }
        }
    }

    &__copy-right {
        margin: 0;
        color: white;
        font-size: 12px;
        font-weight: 300;

        @media (min-width: 1024px) {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }

    &--contact {
        @media (min-width: 1024px) {
            margin-top: 0;
        }

        @media (min-width: 1366px) {
            margin-top: -50px;
        }
    }

    &--hidden {
        display: none;
    }

    .svg-facebook-icon {
        @media (min-width: 1024px) {
            top: 12px;
            right: auto;
            left: 48px;
        }

        @media (min-width: 1366px) {
            top: 10px;
            right: auto;
            left: 200px;
        }

        @media (min-width: 1920px) {
            left: 22%;
        }
    }
}
</style>
